import React, { useEffect, useState, useRef } from 'react';
import { TrendingUp, RefreshCw, Edit3, Check, X } from 'lucide-react';
import useExchangeRate from '../../store/exchangeRateStore';
import useLang from '../../i18n';

export default function ExchangeRateWidget() {
  const { rate, lastUpdated, isLoading, error, isManual, fetchRate, setManualRate } = useExchangeRate();
  const { t } = useLang();
  const [editMode, setEditMode] = useState(false);
  const [inputVal, setInputVal] = useState('');
  const inputRef = useRef();

  // Fetch on mount, then every 10 minutes
  useEffect(() => {
    fetchRate();
    const interval = setInterval(fetchRate, 10 * 60 * 1000);
    return () => clearInterval(interval);
  }, []);

  const handleEdit = () => { setInputVal(String(rate)); setEditMode(true); setTimeout(() => inputRef.current?.focus(), 50); };
  const handleSave = () => { if (inputVal && parseFloat(inputVal) > 0) setManualRate(inputVal); setEditMode(false); };
  const handleKeyDown = (e) => { if (e.key === 'Enter') handleSave(); if (e.key === 'Escape') setEditMode(false); };

  const fmtRate = (r) => new Intl.NumberFormat('en-US', { maximumFractionDigits: 2 }).format(r);
  const timeSince = lastUpdated
    ? new Date(lastUpdated).toLocaleTimeString('en-US', { hour:'2-digit', minute:'2-digit' })
    : '—';

  return (
    <div className="flex items-center gap-1.5 px-3 py-1.5 bg-gray-50 border border-gray-200 rounded-xl text-xs">
      <TrendingUp className={`w-3.5 h-3.5 flex-shrink-0 ${error ? 'text-amber-500' : 'text-green-500'}`} />

      <span className="text-gray-400 hidden sm:inline">USD:</span>

      {editMode ? (
        <div className="flex items-center gap-1">
          <input ref={inputRef} type="number" value={inputVal} onChange={e => setInputVal(e.target.value)}
            onKeyDown={handleKeyDown} placeholder={String(rate)}
            className="w-16 px-1.5 py-0.5 text-xs border border-blue-400 rounded-lg outline-none text-center font-bold" />
          <button onClick={handleSave} className="text-green-600 hover:text-green-700"><Check className="w-3 h-3"/></button>
          <button onClick={() => setEditMode(false)} className="text-red-400 hover:text-red-600"><X className="w-3 h-3"/></button>
        </div>
      ) : (
        <>
          <span className="font-bold text-gray-800">{fmtRate(rate)}</span>
          <span className="text-gray-400">؋</span>
          {isManual && <span className="text-[9px] text-amber-600 bg-amber-50 px-1 rounded">{t('manualRate')}</span>}
          {error && !isManual && <span className="text-[9px] text-amber-600 bg-amber-50 px-1 rounded hidden sm:inline">offline</span>}
          {lastUpdated && !error && <span className="text-gray-300 hidden md:inline">{timeSince}</span>}

          <button onClick={handleEdit} title={t('updateRate')}
            className="text-gray-300 hover:text-blue-500 transition-colors ml-0.5">
            <Edit3 className="w-3 h-3"/>
          </button>
          <button onClick={fetchRate} disabled={isLoading} title="بروزرسانی"
            className="text-gray-300 hover:text-green-500 transition-colors disabled:opacity-40">
            <RefreshCw className={`w-3 h-3 ${isLoading ? 'animate-spin' : ''}`}/>
          </button>
        </>
      )}
    </div>
  );
}
